const ITEMS = [
  { color: "#ff4d4d", label: "Airport FRZ", sub: "Strict no fly" },
  { color: "#e11d48", label: "Prohibited", sub: "Strict no fly" },
  { color: "#ff7849", label: "Restricted", sub: "Permission only" },
  { color: "#ffaa00", label: "Danger / Military", sub: "Caution hazard" },
  { color: "#3399ff", label: "Council / Bylaw", sub: "Permit needed" },
  { color: "#b388ff", label: "SSSI", sub: "Protected nature" },
  { color: "#2ec4b6", label: "Open G Airspace", sub: "Safe to 400ft" },
];

const CLASS_NOTES = {
  sub250: { code: "A1 / C0", note: "May fly close to people — never over crowds" },
  a2: { code: "A2 / C1", note: "Keep 30m from uninvolved people" },
  heavy: { code: "A3", note: "Keep 150m from residential, commercial & recreational areas" },
};

export const Legend = ({ weightClass = "a2" }) => {
  const cls = CLASS_NOTES[weightClass];
  return (
    <div
      data-testid="map-legend"
      className="hidden sm:block absolute bottom-6 right-4 z-[500] bg-black/70 backdrop-blur-xl border border-white/15 rounded-2xl p-4 shadow-2xl max-w-[260px]"
    >
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-200 mb-3 font-heading">Airspace Legend</p>
      <div className="space-y-2">
        {ITEMS.map((it) => (
          <div key={it.label} className="flex items-center gap-2.5">
            <span className="w-3.5 h-3.5 rounded-sm shrink-0" style={{ background: it.color }} />
            <div className="leading-tight">
              <span className="text-sm font-medium text-white">{it.label}</span>
              <span className="text-xs text-zinc-300 ml-1.5">{it.sub}</span>
            </div>
          </div>
        ))}
        <div className="flex items-center gap-2.5">
          <span className="w-3.5 h-3.5 rounded-full shrink-0 bg-[#2ec4b6] border border-white/60" />
          <div className="leading-tight">
            <span className="text-sm font-medium text-white">Hot Spot</span>
            <span className="text-xs text-zinc-300 ml-1.5">Top flying location</span>
          </div>
        </div>
      </div>
      <div data-testid="active-class-note" className="mt-3 pt-3 border-t border-white/15">
        <p className="text-xs font-bold uppercase tracking-[0.15em] text-[#2ec4b6]">{cls.code} rules active</p>
        <p className="text-sm text-zinc-200 mt-1 leading-snug">{cls.note}</p>
      </div>
      <p className="text-xs text-zinc-400 mt-2">Official NATS AIP airspace data</p>
    </div>
  );
};
